module.exports = __webpack_public_path__ + "img/transfer.45a276c3.svg";